<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div class="layout--main" :class="[navbarClasses, footerClasses, { 'app-page': isAppPage }]">
        <!-- <the-customizer
      @updateNavbar="updateNavbar"
      @updateNavbarColor="updateNavbarColor"
      :navbarType="navbarType"
      :navbarColor="navbarColor"
      :footerType="footerType"
      @updateFooter="updateFooter"
      :routerTransition="routerTransition"
      @updateRouterTransition="updateRouterTransition"
      v-if="!disableCustomizer"
      :hideScrollToTop="hideScrollToTop"
      @toggleHideScrollToTop="toggleHideScrollToTop"
    />-->
        <vx-sidebar
            :sidebarItems="sidebarItems"
            :logo="require('@/assets/images/newIklient/iklientLogo.svg')"
            :logosmall="require('@/assets/images/newIklient/IK_symbol.svg')"
            title
            parent=".layout--main"
        />

        <div id="content-area" :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]">
            <div id="content-overlay"></div>

            <div class="content-wrapper">
                <the-navbar :navbarColor="navbarColor" :class="[{ 'text-white': isNavbarDark && !isThemeDark }, { 'text-base': !isNavbarDark && isThemeDark }]" />

                <div class="router-view">
                    <div class="router-content" :class="{ 'mt-0': navbarType == 'hidden' }">
                        <transition :name="routerTransition">
                            <div class="router-header flex flex-wrap items-center mb-6" v-if="$route.meta.breadcrumb || $route.meta.pageTitle">
                                <div class="content-area__heading" :class="{ 'pr-4 border-0 md:border-r border-t-0 border-b-0 border-l-0 border-solid border-grey-light': $route.meta.breadcrumb }">
                                    <h2 class="mb-1">{{ routeTitle }}</h2>
                                </div>

                                <!-- BREADCRUMB -->
                                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" />

                                <!-- DROPDOWN -->
                                <vs-dropdown class="ml-auto md:block hidden cursor-pointer" vs-trigger-click>
                                    <vs-button radius icon="icon-settings" icon-pack="feather"></vs-button>

                                    <vs-dropdown-menu class="w-32">
                                        <vs-dropdown-item>
                                            <div @click="$router.push('/pages/profile')" class="flex items-center">
                                                <feather-icon icon="UserIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                                                <span>Profile</span>
                                            </div>
                                        </vs-dropdown-item>

                                        <vs-dropdown-item>
                                            <div @click="$router.push('/apps/todo')" class="flex items-center">
                                                <feather-icon icon="CheckSquareIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                                                <span>Tasks</span>
                                            </div>
                                        </vs-dropdown-item>

                                        <vs-dropdown-item>
                                            <div @click="$router.push('/apps/email')" class="flex items-center">
                                                <feather-icon icon="MailIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                                                <span>Inbox</span>
                                            </div>
                                        </vs-dropdown-item>
                                    </vs-dropdown-menu>
                                </vs-dropdown>
                            </div>
                        </transition>
                        <div class="content-area__content" v-if="!this.loading">
                            <back-to-top bottom="5%" visibleoffset="500" v-if="!hideScrollToTop">
                                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg" />
                            </back-to-top>
                            <transition :name="routerTransition" mode="out-in">
                                <router-view @changeRouteTitle="changeRouteTitle"></router-view>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>

            <the-footer></the-footer>
        </div>
    </div>
</template>

<script>
import VxSidebar from '@/layouts/components/vx-sidebar/VxSidebar.vue';
import TheNavbar from '../components/TheNavbar.vue';
import TheCustomizer from '../components/customizer/TheCustomizer.vue';
import TheFooter from '../components/TheFooter.vue';
import themeConfig from '@/../themeConfig.js';
//import sidebarItems from "@/layouts/components/vx-sidebar/sidebarItems.js";
import BackToTop from 'vue-backtotop';
import { mapGetters } from 'vuex';
import i18n from '../../i18n/i18n';

export default {
    data() {
        return {
            navbarType: themeConfig.navbarType || 'floating',
            navbarColor: themeConfig.navbarColor || '#fff',
            footerType: themeConfig.footerType || 'static',
            routerTransition: themeConfig.routerTransition || 'none',
            isNavbarDark: false,
            routeTitle: this.$route.meta.pageTitle,
            sidebarItems: [
                {
                    url: '/',
                    name: 'Přehled',
                    slug: 'home',
                    icon: 'HomeIcon',
                    i18n: 'menu.dashboard',
                },
                {
                    url: '/news',
                    name: 'Novinky',
                    slug: 'news',
                    icon: 'FileTextIcon',
                    i18n: 'menu.news',
                },
                {
                    url: null,
                    name: 'Kliniky',
                    icon: 'UsersIcon',
                    slug: 'clinics',
                    submenu: this.newLocations,
                    i18n: 'menu.clinics',
                },
                {
                    url: '/appointments',
                    name: 'Objednávky',
                    slug: 'visits',
                    icon: 'CheckSquareIcon',
                    i18n: 'menu.appointments',
                },
                // {
                //   url: "/calendar",
                //   // url: null,
                //   name: "Calendar",
                //   slug: "calendar",
                //   icon: "CalendarIcon",
                //   i18n: "Calendar"
                // },
                /*
        {
          url: null,
          name: "Financování",
          icon: "DollarSignIcon",
          slug: "financing",
          i18n: "menu.financing",
          submenu: [
            {
              url: "/financing/request",
              name: "Žádost o úver",
              slug: "requests",
              icon: "FileIcon",
              i18n: "menu.financingRequest"
            },
            {
              url: "/documents",
              name: "Smlouvy",
              slug: "documents",
              icon: "FileIcon",
              i18n: "menu.financingDocuments"
            }
            // {
            //   url: "/credit",
            //   // url: null,
            //   name: "Přehled kreditu",
            //   slug: "credit",
            //   icon: "CalendarIcon",
            //   i18n: ""
            // }
          ]
        }*/
            ],
            disableCustomizer: themeConfig.disableCustomizer,
            windowWidth: window.innerWidth, //width of windows
            hideScrollToTop: themeConfig.hideScrollToTop,
            disableThemeTour: themeConfig.disableThemeTour,
            loading: false,
            steps: [
                {
                    target: '#btnSidebarToggler',
                    content: 'Toggle Collapse Sidebar.',
                },
                {
                    target: '.vx-navbar__starred-pages',
                    content: 'Create your own bookmarks. You can also re-arrange them using drag & drop.',
                },
                {
                    target: '.i18n-locale',
                    content: 'You can change language from here.',
                },
                {
                    target: '.navbar-fuzzy-search',
                    content: 'Try fuzzy search to visit pages in flash.',
                },
                {
                    target: '.customizer-btn',
                    content: 'Customize template based your preference',
                    params: {
                        placement: 'left',
                    },
                },
                {
                    target: '.vs-button.buy-now',
                    content: 'Buy this awesomeness at affordable price!',
                    params: {
                        placement: 'top',
                    },
                },
            ],
        };
    },
    watch: {
        $route: {
            immediate: true,
            handler(to, from) {
                this.routeTitle = this.$route.meta.pageTitle;

                // document.title = this.$route.meta.title ? (i18n.t(this.$route.meta.title) + ' - iklient.cz') : 'iklient.cz';

                this.setMetaTitle(this.$route.meta.title);
            },
        },
        newLocations() {
            this.sidebarItems[2].submenu = this.newLocations;
        },
        isThemeDark(val) {
            if (this.navbarColor == '#fff' && val) {
                this.updateNavbarColor('#10163a');
            } else {
                this.updateNavbarColor('#fff');
            }
        },
    },
    computed: {
        userInfo() {
            return this.getUserInfo();
        },
        newLocations() {
            return this.getSideBarMenuLocations();
        },
        isAppPage() {
            if (this.$route.path.includes('/apps/')) return true;
            else return false;
        },
        isThemeDark() {
            return this.$store.state.theme == 'dark';
        },
        sidebarWidth() {
            return this.$store.state.sidebarWidth;
        },
        bodyOverlay() {
            return this.$store.state.bodyOverlay;
        },
        contentAreaClass() {
            if (this.sidebarWidth == 'default') return 'content-area-default';
            else if (this.sidebarWidth == 'reduced') return 'content-area-reduced';
            else if (this.sidebarWidth) return 'content-area-full';
        },
        navbarClasses() {
            return {
                'navbar-hidden': this.navbarType == 'hidden',
                'navbar-sticky': this.navbarType == 'sticky',
                'navbar-static': this.navbarType == 'static',
                'navbar-floating': this.navbarType == 'floating',
            };
        },
        footerClasses() {
            return {
                'footer-hidden': this.footerType == 'hidden',
                'footer-sticky': this.footerType == 'sticky',
                'footer-static': this.footerType == 'static',
            };
        },
    },
    methods: {
        changeRouteTitle(title) {
            this.routeTitle = title;
        },
        updateNavbar(val) {
            if (val == 'static') this.updateNavbarColor('#fff');
            this.navbarType = val;
        },
        updateNavbarColor(val) {
            this.navbarColor = val;
            if (val == '#fff') this.isNavbarDark = false;
            else this.isNavbarDark = true;
        },
        updateFooter(val) {
            this.footerType = val;
        },
        updateRouterTransition(val) {
            this.routerTransition = val;
        },
        handleWindowResize(event) {
            this.windowWidth = event.currentTarget.innerWidth;
            this.setSidebarWidth();
        },
        setSidebarWidth() {
            if (this.windowWidth < 1200) {
                this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', false);
                this.$store.dispatch('updateSidebarWidth', 'no-sidebar');
                this.disableThemeTour = true;
            } else if (this.windowWidth < 1200) {
                this.$store.dispatch('updateSidebarWidth', 'reduced');
            } else {
                this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true);
            }
        },
        toggleHideScrollToTop(val) {
            this.hideScrollToTop = val;
        },
    },
    components: {
        VxSidebar,
        TheNavbar,
        TheFooter,
        TheCustomizer,
        BackToTop,
    },
    created() {
        this.setSidebarWidth();
        if (this.navbarColor == '#fff' && this.isThemeDark) {
            this.updateNavbarColor('#10163a');
        } else {
            this.updateNavbarColor(this.navbarColor);
        }

        /*this.loading = true;
    this.$vs.loading({
      scale: 0.6
    });
    this.$store.dispatch("getInitData").then(() => {
      this.loading = false;
      this.$vs.loading.close();
    });*/
    },
    beforeMount() {},
    mounted() {
        this.sidebarItems[2].submenu = this.newLocations;
        this.$store.dispatch('updateFileIds', this.userInfo.profilePhotoId);
    },
};
</script>
<style lang="scss">
.vs-button.small {
    font-size: 0.9em;
}

.vs-avatar-profile-big > span {
    font-size: 80px;
    color: white;
}

.vs-avatart-location-big,
.vs-avatart-location-medium,
.vs-avatart-location-small,
.vs-avatart-location-mini {
    position: relative;
}

.vs-avatart-location-big::before,
.vs-avatart-location-medium::before,
.vs-avatart-location-small::before {
    font-family: 'Material Icons';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: white;
}

.vs-avatart-location-big::before {
    content: '\E7F1';
    font-size: 60px;
}

.vs-avatart-location-medium::before {
    content: '\E7F1';
    font-size: 40px;
}

.vs-avatart-location-small::before {
    content: '\E7F1';
    font-size: 25px;
}

.vs-avatart-location-mini::before {
    content: '\E7F1';
    font-family: 'Material Icons';
    position: absolute;
    left: 10px;
    top: 4px;
    font-size: 20px;
    color: white;
}

.vs-avatart-location-big > span,
.vs-avatart-location-medium > span,
.vs-avatart-location-small > span,
.vs-avatart-location-mini > span {
    display: none !important;
}

.ps > .ps__scrollbar-y-rail {
    opacity: 0.6 !important;
}
select {
    -moz-appearance: none;
    -webkit-appearance: none;
    padding: 10px;
    font-size: 1rem;
    border: 1px solid rgba(0, 0, 0, 0.2);
    color: inherit;
    width: 100%;
    position: relative;
    padding: 7px;
    border-radius: 5px;

    padding-right: 20px;
    overflow: hidden;
    // height: 100%;

    text-overflow: ellipsis;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz4NCjxzdHlsZT4uY2xzLTF7ZmlsbDpub25lO30uY2xzLTJ7ZmlsbDojMDAwO308L3N0eWxlPjwvZGVmcz48dGl0bGU+YXJyb3dzPC90aXRsZT48cmVjdCBjbGFzcz0iY2xzLTEiIHdpZHRoPSI0Ljk1IiBoZWlnaHQ9IjEwIi8+PHBvbHlnb24gY2xhc3M9ImNscy0yIiBwb2ludHM9IjEuNDEgNC42NyAyLjQ4IDMuMTggMy41NCA0LjY3IDEuNDEgNC42NyIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIzLjU0IDUuMzMgMi40OCA2LjgyIDEuNDEgNS4zMyAzLjU0IDUuMzMiLz48L3N2Zz4=);
    background-repeat: no-repeat;
    background-color: white;
    background-position: calc(100% - 10px) 50%;
}
@media (min-width: 1800px) {
    .xxl\:w-1 {
        width: 0.25rem !important;
    }

    .xxl\:w-2 {
        width: 0.5rem !important;
    }

    .xxl\:w-3 {
        width: 0.75rem !important;
    }

    .xxl\:w-4 {
        width: 1rem !important;
    }

    .xxl\:w-5 {
        width: 1.25rem !important;
    }

    .xxl\:w-6 {
        width: 1.5rem !important;
    }

    .xxl\:w-8 {
        width: 2rem !important;
    }

    .xxl\:w-10 {
        width: 2.5rem !important;
    }

    .xxl\:w-12 {
        width: 3rem !important;
    }

    .xxl\:w-16 {
        width: 4rem !important;
    }

    .xxl\:w-24 {
        width: 6rem !important;
    }

    .xxl\:w-32 {
        width: 8rem !important;
    }

    .xxl\:w-48 {
        width: 12rem !important;
    }

    .xxl\:w-64 {
        width: 16rem !important;
    }

    .xxl\:w-auto {
        width: auto !important;
    }

    .xxl\:w-px {
        width: 1px !important;
    }

    .xxl\:w-1\/2 {
        width: 50% !important;
    }

    .xxl\:w-1\/3 {
        width: 33.33333% !important;
    }

    .xxl\:w-2\/3 {
        width: 66.66667% !important;
    }

    .xxl\:w-1\/4 {
        width: 25% !important;
    }

    .xxl\:w-3\/4 {
        width: 75% !important;
    }

    .xxl\:w-1\/5 {
        width: 20% !important;
    }

    .xxl\:w-2\/5 {
        width: 40% !important;
    }

    .xxl\:w-3\/5 {
        width: 60% !important;
    }

    .xxl\:w-4\/5 {
        width: 80% !important;
    }

    .xxl\:w-1\/6 {
        width: 16.66667% !important;
    }

    .xxl\:w-5\/6 {
        width: 83.33333% !important;
    }

    .xxl\:w-1\/12 {
        width: 8.33333% !important;
    }

    .xxl\:w-2\/12 {
        width: 16.66667% !important;
    }

    .xxl\:w-3\/12 {
        width: 25% !important;
    }

    .xxl\:w-4\/12 {
        width: 33.33333% !important;
    }

    .xxl\:w-5\/12 {
        width: 41.66667% !important;
    }

    .xxl\:w-6\/12 {
        width: 50% !important;
    }

    .xxl\:w-7\/12 {
        width: 58.33333% !important;
    }

    .xxl\:w-8\/12 {
        width: 66.66667% !important;
    }

    .xxl\:w-9\/12 {
        width: 75% !important;
    }

    .xxl\:w-10\/12 {
        width: 83.33333% !important;
    }

    .xxl\:w-11\/12 {
        width: 91.66667% !important;
    }

    .xxl\:w-full {
        width: 100% !important;
    }

    .xxl\:w-screen {
        width: 100vw !important;
    }

    .xxl\:z-0 {
        z-index: 0 !important;
    }

    .xxl\:z-10 {
        z-index: 10 !important;
    }

    .xxl\:z-20 {
        z-index: 20 !important;
    }

    .xxl\:z-30 {
        z-index: 30 !important;
    }

    .xxl\:z-40 {
        z-index: 40 !important;
    }

    .xxl\:z-50 {
        z-index: 50 !important;
    }

    .xxl\:z-auto {
        z-index: auto !important;
    }
}
.vs-slider--circles:active .text-circle-slider {
    white-space: nowrap !important;
}
.vs-slider--circle-text {
    -webkit-transition-property: none;
    -moz-transition-property: none;
    -o-transition-property: none;
    transition-property: none;
}
.con-vs-loading {
    // otherwise vs-popup is overlayed
    z-index: 1000;
}
body > .con-vs-loading {
    z-index: 10000000;
}
.vs-checkbox-primary input:checked + .vs-checkbox {
    background: rgba(var(--vs-primary), 1);
}
.vs-checkbox {
    margin-right: 8px;
    flex-shrink: 0;
    align-self: end;
}
.vs-radio {
    flex-shrink: 0;
    align-self: end;
}
.vdp-datepicker__calendar {
    z-index: 100000 !important;
}
.validation-error-msg,
.span-text-validation-danger .span-text-validation {
    display: block;
    font-weight: bold;
    background: rgba(255, 0, 0, 0.71);
    color: white !important;
    padding: 5px 10px;
    margin: 5px 0;
    border-radius: 3px;
}
</style>
